import { SkinDefaultComponent } from './skin-default.component';
import { SkinUniverseComponent } from './skin-universe.component';

export { SkinDefaultComponent, SkinUniverseComponent };

